import { render, staticRenderFns } from "./LaboratoryProcedure.vue?vue&type=template&id=25496dd8&scoped=true"
import script from "./LaboratoryProcedure.vue?vue&type=script&lang=js"
export * from "./LaboratoryProcedure.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryProcedure.vue?vue&type=style&index=0&id=25496dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25496dd8",
  null
  
)

export default component.exports